import { WebhooksTable } from "./table"
export const Webhooks = () => {
  return <WebhooksTable />
}
